@use '../common/colors.scss' as colors;
@use '../common/vars.scss' as vars;

.adverse-wrapper {
  width: 100%;
}

:global(.header-txt).adverse-header {
  text-align: center;
  margin: 32px 0;
  line-height: 33px;

  h2 {
    font-size: 1em;
    letter-spacing: -0.1px;
  }

  @media screen and (max-width: vars.$mobile) {
    font-size: 24px;
  }
}

.adverse-body a {
  color: colors.$link;

  &:hover {
    color: colors.$uplift-green;
    text-decoration: underline;
  }
}

.adverse-body {
  color: colors.$body-text;
}

.body {
  margin: 0 auto;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: vars.$mobile) {
    width: 100%;
  }
}

:global(.header-txt).header {
  margin-top: 1.25em;
  margin-bottom: 0.75em;
  text-align: center;
  line-height: 33px;

  @media screen and (max-width: vars.$mobile) {
    font-size: 1.5em;
  }
}

.text {
  color: colors.$body-text;

  & > * {
    margin-bottom: 10px;
  }
}

// Flexpay
:global(.flexpay) {
  :global(.noi-header) {
    text-align: left;
  }

  :global(.header-txt).header {
    text-align: left;
  }
}
